module.exports = __webpack_public_path__ + "img/stock2.e1082412.png";